import { render, staticRenderFns } from "./product-list-exponea-event.vue?vue&type=template&id=53b5828e&scoped=true"
import script from "./product-list-exponea-event.vue?vue&type=script&lang=js"
export * from "./product-list-exponea-event.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b5828e",
  null
  
)

export default component.exports